import React from 'react';

import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';

// Styles
const ImagePlaceholder = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 4px;
  padding: 2px;

  ${({ height }) => {
    if (height) {
      return css`
        height: ${height}px;
      `;
    } else {
      return css`
        height: auto;
      `;
    }
  }}

  width: ${({ width }) => width}px;
  font-weight: 700;
  border: 4.39315px solid ${({ theme }) => theme.colors.white};
  box-shadow: 0px 2.19658px 4.39315px ${({ theme }) => theme.colors.gray200};
  background: ${({ theme }) => theme.colors.lavender250};
  color: ${({ theme }) => theme.colors.promo};
  text-align: center;
`;

// Components
const ProductPlaceholderImage = ({ children, width = 86, height }) => {
  return (
    <ImagePlaceholder width={width} height={height}>
      {children}
    </ImagePlaceholder>
  );
};

ProductPlaceholderImage.propTypes = {
  children: PropTypes.node,
  height: PropTypes.number,
  width: PropTypes.number,
};

export default ProductPlaceholderImage;
